var React = require('react');

function Wifi (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 33a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm-7.5 4.5A7.5 7.5 0 0124 30a7.5 7.5 0 017.5 7.5A7.5 7.5 0 0124 45a7.5 7.5 0 01-7.5-7.5zm-4.173-11.667c6.444-6.443 16.89-6.443 23.334 0a1.5 1.5 0 11-2.122 2.122c-5.272-5.273-13.818-5.273-19.09 0a1.5 1.5 0 01-2.122-2.122z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.97 19.47c9.957-9.958 26.103-9.958 36.06 0a1.5 1.5 0 11-2.12 2.12c-8.787-8.786-23.033-8.786-31.82 0a1.5 1.5 0 11-2.12-2.12z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M.477 12.265c13.25-12.351 33.796-12.351 47.046 0a1.5 1.5 0 11-2.046 2.194C33.38 3.182 14.621 3.182 2.523 14.46a1.5 1.5 0 11-2.046-2.194z","key":2})]);
}

Wifi.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Wifi;

Wifi.default = Wifi;
